export default {
  state: {
    sharer: { opened: false },
    requestHelpForm: { opened: false },
    uploadForm: { opened: false },
    complainForm: { opened: false },
    volunteersForm: { opened: false },
    partnersForm: { opened: false },
    politicsPopup: { opened: false },
    contractPopup: { opened: false },
    projectAboutPopup: { opened: false },
    mobileMenu: { opened: false }
  },
  actions: {
    /**
     * Отправляет новую заявку от пользователя на сервер
     */
    async requestNewPost(ctx, { API, data }) {
      return await fetch(`${API}/materials/list`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        }
      });
    },
    /**
     * Отправляет заявку от пользователя на сервер
     */
    async sendRequest(ctx, { API, body }) {
      return await fetch(`${API}`, {
        method: "POST",
        body
      });
    }
  },
  mutations: {
    managePopupState(state, { popup, _state }) {
      state[popup].opened = _state;
    }
  },
  getters: {
    forms: state => state
  }
};
